import type { PepLocale } from "../../i18n/types";
import {
  localizeAudience,
  type ProductAudienceItem,
} from "./product-detail-types";

interface ProductAudienceGridProps {
  locale: PepLocale;
  items: ProductAudienceItem[];
  title?: string;
}

export function ProductAudienceGrid({
  locale,
  items,
  title,
}: ProductAudienceGridProps) {
  if (!items.length) return null;

  const heading =
    title ??
    (locale === "en"
      ? "A complete solution for every stakeholder"
      : "Une solution complète pour chaque acteur");

  return (
    <section className="pep-pd-section" aria-labelledby="pep-pd-audience-title">
      <div className="container">
        <h2 id="pep-pd-audience-title" className="pep-pd-section__title">
          {heading}
        </h2>
        <ul className="pep-pd-audience">
          {items.map((item) => {
            const { title: t, body } = localizeAudience(item, locale);
            return (
              <li key={item.id} className="pep-pd-audience__item">
                <span className="pep-pd-audience__icon" aria-hidden>
                  {item.icon}
                </span>
                <h3 className="pep-pd-audience__title">{t}</h3>
                <p className="pep-pd-audience__body">{body}</p>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
